import React from 'react';
import {Grid, Typography} from '@mui/material';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import {Trans, useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch} from 'react-redux';

import {unpackId} from 'common/diplomatIdUtil';

import {useDeleteApi} from 'common/hooks/useDeleteApi';
import api from 'api';
import {layoutActions} from 'features/layout/redux';
import {get} from 'lodash';

type DeleteVFSNodeDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeleteVFSNodeDialog = ({data, onClose}: DeleteVFSNodeDialogProps) => {
   const {t} = useTranslation();

   const {id} = unpackId(data.id);
   // console.debug('delete vfs', data);

   const dispatch = useDispatch();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };
   const {request: onConfirm} = useDeleteApi(api.vfs, {
      onSuccess,
   });

   return (
      <Dialog maxWidth="sm" header={t('Delete Filesystem Node')} close={onClose}>
         <Panel root>
            <Typography>
               <Trans t={t}>Do you really want to Delete Filesystem Node "{data.name}"?</Trans>
            </Typography>
         </Panel>
         <Grid container spacing={2} justifyContent={'center'}>
            <Grid item>
               <PrimaryButton
                  onClick={() =>
                     onConfirm({
                        body: JSON.stringify({
                           vfspath: get(data, 'path'),
                           force: true,
                        }),
                     })
                  }
               >
                  {t('OK')}
               </PrimaryButton>
            </Grid>
            <Grid item>
               <Button onClick={onClose}>{t('Cancel')}</Button>
            </Grid>
         </Grid>
      </Dialog>
   );
};

export default DeleteVFSNodeDialog;
